module.exports = __webpack_public_path__ + "static/media/legs-quizz.18bc184d.jpg";